import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';
import { useGlobalStore } from '@/features/Global/store';

export class ElementargefahrenBetroffen extends AbstractRequirementMapper {
  protected frontendKey = new Map(
    Object.entries({
      woh: 'elementargefahren_betroffen',
      hau: 'elementargefahren.betroffen',
    }),
  );

  public getValues(): number[] | boolean[] {
    if (useGlobalStore().sparte === 'woh') {
      return super.getValues().map((v) => v.toString());
    }

    return super.getValues();
  }
}
